exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chcek-box[data-v-443a971f]{display:inline-block;width:15px;height:15px;border-radius:3px;border:1px solid #666}", ""]);

// exports
